import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Tip from "@/pages/Tip";
import Unsubscribe from "@/pages/Unsubscribe";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <div className="App noise-overlay vignette">
      <BrowserRouter>
        <SmoothScroll />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0A0B0E",
              border: "1px solid rgba(255,159,10,0.3)",
              color: "#F2F3F5",
              fontFamily: "'Share Tech Mono', monospace",
              borderRadius: 0,
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/tip" element={<Tip />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
